import './navigation/Header.css';
import './WaterSystemSearchModal.css';
import { IconButton } from '@utahdts/utah-design-system';
import { useWaterSystemSearchModal } from './WaterSystemSearchModalContext';

const SelectedWaterSystemHeader = () => {
    // Get selected water system from context
    const { selectedWaterSystem, setShowSystemSelectModal } = useWaterSystemSearchModal();
    
    const system = selectedWaterSystem || {};
    const pwsId = system.pwsId;
    const systemName = system.systemName;
    const county = system.countyServed || "";
  return (
    <>
      <div className='utah-design-system selected-water-system' onClick={() => { setShowSystemSelectModal(true); }}>
          <IconButton
            appearance='borderless'
            color='primary'
            icon={<span className={'utds-icon-before-search'} aria-hidden='true'
            />}
            style={{ alignSelf: 'flex-start', marginLeft: '10px' }}
            aria-label="Search for water system"
            tooltipText="Search for water system"
          />
        <span className='selected-water-system-name'>
          {(pwsId && systemName)
            ? <><strong>{pwsId}</strong> - {systemName}</>
            : <strong>No Water System Selected</strong>
          }
        </span>
        <div className='selected-water-system-county'>
          <span>{county}</span>
        </div>
      </div>
    </>
  );
}

export default SelectedWaterSystemHeader;